import * as React from 'react';
import CardMedia from '@mui/material/CardMedia';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, colors } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SetFormState, DownloadTemplate } from '../actions/FocusOccasionUploadActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

export default function MediaCard() {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const _generate = () => {
		dispatch(DownloadTemplate());
	};

	return (
		<Card>
			<CardContent>
				<Typography gutterBottom variant="h4" component="div">
					Important
				</Typography>
				<Typography variant="body1" gutterBottom>
					This module its only to upload files with specific nomenclature such:
				</Typography>
				<Typography variant="body1" gutterBottom>
					- Focus_Occasion_Events (.xlsx)
				</Typography>
				<br />
				<Button className={classes.generate} onClick={_generate} variant="contained">Download Template</Button>
			</CardContent>
		</Card>
	);
}
